module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("THIS BOOK IS DEDICATED"), _c('br'), _vm._v("TO"), _c('br'), _c('span', {
    staticClass: "big2"
  }, [_vm._v("ALEX. ERSKINE")]), _c('br'), _vm._v("HYPNOLOGIST, PHILOSOPHER,"), _c('br'), _vm._v("AND FRIEND OF HUMANITY"), _c('br'), _vm._v("AND"), _c('br'), _vm._v("TO THOSE WHO HAVE GONE ON"), _c('br'), _vm._v("BEFORE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539dbde6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 60
// module chunks = 0